import { AccountFilter } from "@bitwarden/web-vault/app/models/types/filter.types";
import { InstitutionView } from "@bitwarden/web-vault/app/models/view/institution/institution.view";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";
import { inject, Injectable } from "@angular/core";
import { FilterControlType } from "@bitwarden/web-vault/app/services/store/calculation-base/controls/filter.control";

@Injectable({
  providedIn: "root",
})
export class ViewsFilterAccountHelper {
  private userStore = inject(UserStoreService);

  getFilter(
    options: FilterControlType,
    selected: FilterControlType,
    institutionView: InstitutionView,
  ): Map<string, AccountFilter> {
    return this.accountFilterOfInstitution(options, selected, institutionView);
  }

  private accountFilterOfInstitution(
    options: FilterControlType,
    selected: FilterControlType,
    institutionView: InstitutionView,
  ) {
    const isSelectedCountry = selected.countries.includes(institutionView.swift.countryCode);
    const isSelectedInsto = selected.institutions.includes(institutionView.id);
    const accountsFilterMap: Map<string, AccountFilter> = new Map();
    const accountViews = this.userStore.enrichAccounts.collection();
    const institutionAccounts = accountViews.filter(
      (account) =>
        options.accounts.includes(account.id) &&
        institutionView.id === account.institutionLink.institutionId,
    );
    for (const accountView of institutionAccounts) {
      const accountFilter: AccountFilter = {
        view: accountView,
        isSelected:
          isSelectedCountry && isSelectedInsto && selected.accounts.includes(accountView.id),
        isDisabled: !isSelectedCountry || !isSelectedInsto,
      };

      accountsFilterMap.set(accountView.id, accountFilter);
    }

    return accountsFilterMap;
  }
}
